import { useEffect, useState } from "react";
import { isDesktop } from "./device.js";
import { T, t } from "./i18n.jsx";
import { C } from "./theme";

// A non-blocking recommendation on every entry route, including /studio and /join.
// Keep the initial notice readable at the fitted scale; pinch zoom is left to the browser.
const fittedScale = () => Math.min(1, (window.screen.width || 390) / 1280);

export default function MobileViewNotice() {
  const [visible, setVisible] = useState(() => !isDesktop());
  const [scale, setScale] = useState(fittedScale);
  useEffect(() => {
    const update = () => setScale(fittedScale());
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);
  if (!visible) return null;
  const px = (n) => n / scale;
  return (
    <aside role="note" style={{
      position: "fixed", bottom: px(12), left: px(12), right: px(12), zIndex: 10000,
      display: "flex", alignItems: "center", gap: px(10), padding: px(12),
      borderRadius: px(10), border: `1px solid ${C.border}`, background: C.panel,
      color: C.hi, fontFamily: "var(--ui), system-ui, sans-serif", fontSize: px(14),
      lineHeight: 1.45, boxShadow: "0 4px 24px rgba(0,0,0,.35)",
    }}>
      <div style={{ flex: 1 }}>
        <T comp="strong">Best viewed on a desktop computer with a high-resolution display.</T>
        <T comp="div" style={{ color: C.mid }}>The desktop layout is scaled to fit your screen. Pinch to zoom.</T>
      </div>
      <button type="button" aria-label={t("Dismiss desktop viewing recommendation")}
        onClick={() => setVisible(false)} style={{
          flexShrink: 0, width: px(44), height: px(44), fontSize: px(24),
          background: "transparent", color: C.hi, border: `1px solid ${C.border}`,
          borderRadius: px(8), cursor: "pointer",
        }}>×</button>
    </aside>
  );
}
